import React from "react";
import Button from "../Button";

export const MockTestCard = ({
    id,
    img,
    question,
    dept,
    text,
    rate,
    rateBg,
    handleViewClick,
}) => {
    const handleCardClick = () => {
        handleViewClick(id);
    };

    return (
        <div
            key={id}
            className=" bg-[#ffff] border-[2px] border-gray-300 flex flex-col gap-2  p-4 rounded-[10px]"
        >
            <div className="flex gap-2 items-center lg:flex-row md:flex-col flex-row  ">
                <img
                    src={img}
                    alt="event-image"
                    className="w-[87px] h-[86px] rounded-[4px] object-cover"
                />
                <div className="flex gap-4 flex-col">
                    <h2 className="text-[14px] leading-[18px] font-ManropeBold">
                        {text}
                    </h2>
                    <p className="text-[#666666] text-[12px] font-ManropeLight ">
                        {question} Questions
                    </p>
                </div>
            </div>


            <div className="w-full bg-[#E0E0E0] h-[6px] flex flex-col  rounded-[5px]">
                <div
                    className={`w-${rate}% h-full rounded-[5px] ${rateBg}`}
                    style={{ width: `${rate}%` }}
                ></div>
            </div>
            <div className=" flex justify-between  text-[11px]">
                    <h2 className="text-[#A3A3A3] font-ManropeLight">12/25 Question</h2>
                    <p className="font-ManropeBold">{rate}%</p>
                </div>


            <div className="w-full flex justify-end gap-6 items-center">
                <button className="text-neutral">Cancel</button>
                <div className=" w-fit">
                    <Button onClick={handleCardClick}>Take Test</Button>
                </div>
            </div>
        </div>
    );
};
